<template>
  <div
    v-if="data"
    id="func-detalhes"
    class="func-detalhe"
  >
    <el-row
      style="padding: 30px 0;"
    >
      <el-col :span="14">
        <div class="border"></div>
        <StatusCard
          :disabled="true"
          :cor="data.situacao.cor"
          style="width: 100%; margin-bottom: 15px;"
        >
          <div class="func-status-card">
            <div class="func-status-card-titulo">
              <h4>{{ data.guia.descricaoTipoServico }}</h4>
            </div>
            <div class="func-status-card-content" style="margin-top: 10px">
              <div class="form-status-card-info">
                <div class="func-status-card-label">
                  <small>Situação</small>
                </div>
                <div
                  class="func-status-card-valor"
                  style="font-weight: 600"
                >
                  <span :style="'color:' +  data.situacao.cor">{{ data.situacao.descricao }}</span>
                </div>
              </div>
            </div>
            <div class="func-status-card-content --flex">
              <div style="margin-top: 10px; flex: 1">
                <div class="func-status-card-label">
                  Data solic.
                </div>
                <div class="func-status-card-valor">
                  {{ data.guia.dataSolicitacao | formatData }}
                </div>
              </div>
              <div style="margin-top: 10px; flex: 1">
                <div class="func-status-card-label">
                  Data autoriz..
                </div>
                <div class="func-status-card-valor">
                  {{ data.guia.dataAutorizacao | formatData }}
                </div>
              </div>
              <div style="margin-top: 10px; flex: 1">
                <div class="func-status-card-label">
                  Data validade
                </div>
                <div class="func-status-card-valor">
                  {{ data.guia.dataValidade | formatData }}
                </div>
              </div>
            </div>
          </div>
        </StatusCard>
        <el-card
          class="protocolo-card"
          style="width: 100%;"
        >
          <div class="func-status-card card-beneficiario">
            <div class="func-status-card-beneficiario">
              <div style="display: flex; border-bottom: 2px dotted #CCCCCC; padding-bottom: 10px">
                <div
                style="flex: 1;"
              >
                <div class="func-status-card-label">
                  BENEFICIÁRIO:
                </div>
                <div
                  class="func-status-card-valor"
                  style="font-weight: 600;"
                >
                  {{ data.nomeBeneficiario }}
                </div>
                <div>
                  <small>{{ data.numeroCartaoBeneficiario}}</small>
                  <span style="margin-left: 10px; font-size: 12px">{{tipoBeneficiario}}</span>
                </div>
              </div>
                <div style="flex: 0.1">
                <div
                  :style="beneficiarioIconeStyle"
                  class="circle"
                >
                  <div class="abreviatura">
                    {{ beneficiario.abreviacao }}
                  </div>
                </div>
              </div>
              </div>
            </div>
            <div class="func-status-card-beneficiario">
              <div style="display: flex">
                <div
                  style="flex: 1; border-bottom: 2px dotted #CCCCCC; padding: 10px 0px;"
                >
                  <div class="func-status-card-label">
                    SOLICITANTE:
                  </div>
                  <div
                    class="func-status-card-valor"
                    style="font-weight: 600;"
                  >
                    {{ data.solicitante.nomeSolicitante }}
                  </div>
                </div>
              </div>
            </div>
            <div class="func-status-card-beneficiario">
              <div style="display: flex">
                <div
                  style="flex: 1; padding-top: 10px;"
                >
                  <div class="func-status-card-label">
                    PRESTADOR:
                  </div>
                  <div
                    class="func-status-card-valor"
                    style="font-weight: 600;"
                  >
                    {{ data.prestador.nome }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-card>

        <div v-for="(evento, i) in data.eventos" :key="i" style="width: 100%">
          <span v-if="evento.textos && evento.textos.titulo && evento.textos.descricao"  style="font-size: 14px;  padding: 5px; margin-bottom: 5px; display: block;"><b>{{evento.descricaoAgrupador}}</b></span>
          <el-card v-if="evento.textos && evento.textos.titulo && evento.textos.descricao"  class="protocolo-card" style="width: 100%;">
            <div class="func-status-card card-beneficiario">
              <div class="func-status-card-beneficiario">
                <div style="display: flex">
                  <div style="flex: 1; padding-top: 10px;">
                    <div v-if="evento.textos && evento.textos.titulo" class="func-status-card-label" style="font-weight: 600;">
                      {{ evento.textos.titulo }}
                    </div>
                    <div v-if="evento.textos && evento.textos.descricao" class="func-status-card-label">
                      {{ evento.textos.descricao }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-card>
          <div v-for="(procedimento, a) in evento.procedimentos" :key="a">
            <CardAccordion style="padding: 5px 0px">
              <template v-slot:numerator>
                {{a + 1}}
              </template>
              <template v-slot:card-title>
                <div style="display: flex;flex-direction: column;line-height: 18px">
                  <span style="font-weight: 600">Tipo de serviço</span>
                  <span class="subTitle">{{procedimento.descricao}}</span>
                </div>
              </template>
              <template v-slot:collapsed>
                <div class="box-card-formulario">
                  <span class="label-card-formulario"> Situação</span>
                  <span class="value-card-formulario">{{procedimento.situacao.descricao}}</span>
                </div>
                <div class="box-card-formulario">
                  <span class="label-card-formulario"> Código</span>
                  <span class="value-card-formulario">{{procedimento.codigo}}</span>
                </div>
                <div class="box-card-formulario">
                  <span class="label-card-formulario"> Data Autorização</span>
                  <span class="value-card-formulario">{{procedimento.dataAutorizacao | formatData}}</span>
                </div>
                <div class="box-card-formulario">
                  <span class="label-card-formulario"> Quant. Solicitada</span>
                  <span class="value-card-formulario">{{procedimento.quantidadeSolicitada}}</span>
                </div>
                <div class="box-card-formulario">
                  <span class="label-card-formulario"> Quant. Autorizada</span>
                  <span class="value-card-formulario">{{procedimento.quantidadeAutorizada}}</span>
                </div>
                <div class="box-card-formulario">
                  <span class="label-card-formulario"> Quant. Executada</span>
                  <span class="value-card-formulario">{{procedimento.quantidadeExecutada}}</span>
                </div>
                <div class="box-card-formulario">
                  <span class="label-card-formulario"> Texto glosa</span>
                  <span class="value-card-formulario">{{procedimento.textoGlosa}}</span>
                </div>
                <div class="box-card-formulario">
                  <span class="label-card-formulario"> <b>{{procedimento.textoProcedimento.titulo}}</b></span>
                  <span class="value-card-formulario">{{procedimento.textoProcedimento.descricao}}</span>
                </div>
              </template>
            </CardAccordion>
          </div>
        </div>
        <div>
        </div>
      </el-col>
      <el-col :span="10">
        <el-card class="protocolo-card">
          <div class="field">
            <small class="protocolo-title">Nº DA GUIA</small>
            <span class="text-blue-max">{{data.guia.numeroProtocolo}}</span>
            <el-button style="float: right" @click="copiar(data.guia.numeroProtocolo)" class="btn-icon">
              <inline-svg :src="require('@/assets/icons/icon_btn_copy.svg')"></inline-svg>
            </el-button>
          </div>
          <div class="field">
            <small class="protocolo-title">SENHA</small>
            <span class="text-blue-max">{{data.guia.senhaAutorizacao}}</span>
            <el-button style="float: right" @click="copiar(data.guia.senhaAutorizacao)" class="btn-icon">
              <inline-svg :src="require('@/assets/icons/icon_btn_copy.svg')"></inline-svg>
            </el-button>
          </div>
        </el-card>
        <button-default v-if="exibeBtnExportar" :title="labelBtnExportar" @click.capture="download"></button-default>
        <div class="func-status-card-label" style="margin-top: 10px">
          {{ textoRodape }}
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import StatusCard from '@/components/cards/StatusCard'
import { mapGetters, mapState } from 'vuex'
import InlineSvg from 'vue-inline-svg'
import moment from 'moment'
import { formatAbreviatura, formatBeneficiarios, getCorAleatoria } from '@/components/GrupoFamiliar/GrupoFamiliarHelpers'
import CardAccordion from '@/components/cards/CardAccordion.vue'
import ButtonDefault from '@/components/buttons/ButtonDefault.vue'
export default {
  data () {
    return {
      data: {},
      showDiv: false
    }
  },
  components: { ButtonDefault, CardAccordion, StatusCard, InlineSvg },
  filters: {
    formatData (value) {
      if (!value) {
        return '-'
      }
      return moment(value).format('DD/MM/YYYY')
    }
  },
  computed: {
    ...mapState('SetupApp', ['apiFuncionalidade', 'funcionalidade']),
    ...mapGetters('Login', ['user', 'contratos', 'beneficiarios', 'hasMultPerfil']),
    aberto () {
      return this.data.despesas.length <= 1
    },
    beneficiario () {
      if (this.data) {
        if (this.hasMultPerfil && this.beneficiarios.length === 0) {
          return {
            nome: this.user.nome,
            cor: getCorAleatoria(),
            abreviacao: formatAbreviatura(this.user.nome),
            chaveUnica: this.user.chaveUnica
          }
        }

        if (this.data.nomeBeneficiario && this.data.numeroContrato) {
          const beneficiarios = formatBeneficiarios(
            [{ chaveUnica: this.data.chaveUnica }],
            this.beneficiarios,
            { numeroContrato: this.data.numeroContrato }
          )
          return beneficiarios[0] || {}
        }
      }
      return {}
    },
    beneficiarioIconeStyle () {
      return {
        background: this.beneficiario.cor
      }
    },
    tipoBeneficiario () {
      let beneficiarioTipo = this.data.idTipoBeneficiario
      let value = ''
      if (beneficiarioTipo === 'T') {
        value = 'Titular'
      }
      if (beneficiarioTipo === 'B') {
        value = 'Beneficiário'
      }
      return value
    },
    labelBtnExportar () {
      return this.funcionalidade.parametros.textos.textoBotaoAutorizacaoPDF
    },
    textoRodape () {
      return this.funcionalidade.parametros.textos.textoRodapeTelaDetalhe
    },
    exibeBtnExportar () {
      return this.funcionalidade.parametros.exibeAutorizacaoPDF
    }
  },
  methods: {
    async init () {
      const res = await this.apiFuncionalidade.detalheExtrato({
        payload: {
          idAutorizacao: this.$route.query.idAutorizacao
        }
      })
      this.data = res.data
    },
    copiar (text) {
      this.$clipboard(text)
    },
    async download () {
      try {
        const res = await this.apiFuncionalidade.extratoPdf({
          payload: {
            idAutorizacao: this.$route.query.idAutorizacao
          }
        })
        if (res.data.url) {
          window.open(res.data.url, '_blank')
        } else if (res.data.base64) {
          const byteString = atob(res.data.base64)
          const mimeString = 'application/pdf'
          const ab = new ArrayBuffer(byteString.length)
          const ia = new Uint8Array(ab)
          for (let i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i)
          }
          const blob = new Blob([ab], { type: mimeString })
          const blobUrl = URL.createObjectURL(blob)
          window.open(blobUrl, '_blank')
        }
      } catch (error) {
        this.$message.error('Não foi possível realizar o download do arquivo. Tente novamente mais tarde.')
      }
    }
  },
  created () {
    this.init()
  }
}
</script>
<style>

.el-collapse {
  background-color: unset;
  border-bottom: none;
  border-top: none;
}

.el-collapse-item__header{
  background-color: unset;
  border-bottom: none;
  border-top: none;
}

.el-collapse-item__wrap {
  background-color: unset;
  border-bottom: none;
  border-top: none;
}
</style>
<style lang="less" scoped>
#func-31-detalhe {
  padding: 15px 20px;
  .func-status-card {
    width: 100%;
    padding: 1px;
  }

  .card-beneficiario {
    padding: 5px;
  }

  .func-status-card-titulo {
    font: normal normal 600 18px/24px Open Sans;
    letter-spacing: 0;
    color: #333333;
  }

  .func-detalhe {
    padding: 0 20px;

    .func-status-card-content {
      display: flex;
      flex-flow: row wrap;

      .form-status-card-info {
        width: 50%;
        margin-top: 10px;
        flex: 1;
      }
    }
  }
  .func-status-card-label {
    font: normal normal normal 11px/15px Open Sans;
    letter-spacing: 0;
    color: #555555;
    word-spacing: 5px;
  }
  .button-cancelar {
    box-shadow: none;
    border: none;
    border-radius: 6px;
    background: #EBF4FA;
  }
  .protocolo-card {
    box-shadow: none;
    border: none;
    border-radius: 6px;
    background: #F6F6F6 0 0 no-repeat padding-box;

    .protocolo-title {
      display: block;
      line-height: 24px;
      color: #555555;
    }
    .text-blue-max {
      color: #006FB9;
      font-weight: 600;
      font-size: 18px;
    }
    .field:first-child {
      margin-bottom: 15px;
    }
  }
  .text-blue-mid {
    color: #006FB9;
    font-weight: 600;
    font-size: 15px;
  }
  .el-col-14 {
    padding-right: 40px;
  }
  .btn {
    width: 100%;
    padding: 20px 15px;
    text-align: left !important;
    margin-bottom: 5px;
  }
  .btn-icon{
    border:none;
    float: right;
  }
  .border {
    border-right: solid 1px #EEEEEE;
    display: block;
    height: 100%;
    position: absolute;
    left: 56.4%;
    top: 1px;
  }
  .abreviatura {
    font-size: 17px;
    color: #FFFFFF;
  }

  .circle {
    height: 35px;
    width: 35px;
    border-radius: 17px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .func-status-card-valor {
    font: normal normal normal 14px/19px Open Sans;
    letter-spacing: 0;
    color: #333333;
    font-weight: 600;
  }
  .--flex {
    display: flex;
    flex-flow: row wrap;
  }
}
</style>
